export default __webpack_public_path__ + "static/media/Let_s Have Some Fun~.5fd4f789.png";